import { Card, CardBody, Col, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { IconsSwitchs } from "../../../../Constant";
import { ICON_SWITCH, ICON_SWITCH_LIST } from "../../../../Data/FormWidgets";
import CommonSwitchSpan from "../Common/CommonSwitchSpan";

const Iconsswitch = () => {
  return (
    <Col xl="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={IconsSwitchs} span={ICON_SWITCH} />
        <CardBody className="common-flex flex-column switch-wrapper">
          {ICON_SWITCH_LIST.map(({ color, text }, index) => (
            <div className="d-flex align-items-center" key={index}>
              <div className="text-end">
                <CommonSwitchSpan color={color} defaultChecked/>
              </div>
              <Label className="m-l-10" check>{text}</Label>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default Iconsswitch;
